import { Link } from 'react-router-dom';

export default function Header() {
    return (
        <header className="header">
            <div className="container header-inner">
                <Link to="/" className="logo">
                    <span className="logo-emoji">🎁</span>
                    PickOneGift
                </Link>
                <nav className="nav">
                    <Link to="/create">Stwórz listę</Link>
                    <Link to="/generator">🪄 Kreator</Link>
                    <a href="#how-it-works">Jak to działa</a>
                    <Link to="/demo">Demo dla sklepów</Link>
                    <Link to="/privacy">Prywatność</Link>
                </nav>
            </div>
        </header>
    );
}
